/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSlumSoccerAwards = /* GraphQL */ `
  mutation CreateSlumSoccerAwards($input: CreateSlumSoccerAwardsInput!) {
    createSlumSoccerAwards(input: $input) {
      awardId
      description
      ef1
      ef2
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const createSlumSoccerBlogs = /* GraphQL */ `
  mutation CreateSlumSoccerBlogs($input: CreateSlumSoccerBlogsInput!) {
    createSlumSoccerBlogs(input: $input) {
      blogId
      date
      description
      ef1
      ef2
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const createSlumSoccerContacts = /* GraphQL */ `
  mutation CreateSlumSoccerContacts($input: CreateSlumSoccerContactsInput!) {
    createSlumSoccerContacts(input: $input) {
      city
      contactId
      contactNumber
      country
      date
      ef1
      email
      enquiry
      name
      __typename
    }
  }
`;
export const createSlumSoccerEvents = /* GraphQL */ `
  mutation CreateSlumSoccerEvents($input: CreateSlumSoccerEventsInput!) {
    createSlumSoccerEvents(input: $input) {
      date
      description
      ef1
      ef2
      eventId
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const createSlumSoccerFundraisers = /* GraphQL */ `
  mutation CreateSlumSoccerFundraisers(
    $input: CreateSlumSoccerFundraisersInput!
  ) {
    createSlumSoccerFundraisers(input: $input) {
      description
      fundraiserId
      goalAmount
      image
      mainContent
      participants
      raisedAmount
      title
      tournamentDetails
      __typename
    }
  }
`;
export const createSlumSoccerGallery = /* GraphQL */ `
  mutation CreateSlumSoccerGallery($input: CreateSlumSoccerGalleryInput!) {
    createSlumSoccerGallery(input: $input) {
      ef1
      galleryId
      imgUrl
      title
      __typename
    }
  }
`;
export const createSlumSoccerNews = /* GraphQL */ `
  mutation CreateSlumSoccerNews($input: CreateSlumSoccerNewsInput!) {
    createSlumSoccerNews(input: $input) {
      description
      ef1
      ef2
      imgUrl
      link
      newsId
      newspaper
      title
      __typename
    }
  }
`;
export const createSlumSoccerPartners = /* GraphQL */ `
  mutation CreateSlumSoccerPartners($input: CreateSlumSoccerPartnersInput!) {
    createSlumSoccerPartners(input: $input) {
      description
      ef1
      imgUrl
      link
      partnerId
      partnershipType
      title
      __typename
    }
  }
`;
export const createSlumSoccerProjects = /* GraphQL */ `
  mutation CreateSlumSoccerProjects($input: CreateSlumSoccerProjectsInput!) {
    createSlumSoccerProjects(input: $input) {
      description
      ef1
      hoverText
      imgUrl
      mainContent
      projectType
      projectid
      title
      __typename
    }
  }
`;
export const createSlumSoccerReports = /* GraphQL */ `
  mutation CreateSlumSoccerReports($input: CreateSlumSoccerReportsInput!) {
    createSlumSoccerReports(input: $input) {
      date
      description
      ef1
      ef2
      imgUrl
      link
      reportId
      title
      __typename
    }
  }
`;
export const deleteSlumSoccerAwards = /* GraphQL */ `
  mutation DeleteSlumSoccerAwards($input: DeleteSlumSoccerAwardsInput!) {
    deleteSlumSoccerAwards(input: $input) {
      awardId
      description
      ef1
      ef2
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const deleteSlumSoccerBlogs = /* GraphQL */ `
  mutation DeleteSlumSoccerBlogs($input: DeleteSlumSoccerBlogsInput!) {
    deleteSlumSoccerBlogs(input: $input) {
      blogId
      date
      description
      ef1
      ef2
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const deleteSlumSoccerContacts = /* GraphQL */ `
  mutation DeleteSlumSoccerContacts($input: DeleteSlumSoccerContactsInput!) {
    deleteSlumSoccerContacts(input: $input) {
      city
      contactId
      contactNumber
      country
      date
      ef1
      email
      enquiry
      name
      __typename
    }
  }
`;
export const deleteSlumSoccerEvents = /* GraphQL */ `
  mutation DeleteSlumSoccerEvents($input: DeleteSlumSoccerEventsInput!) {
    deleteSlumSoccerEvents(input: $input) {
      date
      description
      ef1
      ef2
      eventId
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const deleteSlumSoccerFundraisers = /* GraphQL */ `
  mutation DeleteSlumSoccerFundraisers(
    $input: DeleteSlumSoccerFundraisersInput!
  ) {
    deleteSlumSoccerFundraisers(input: $input) {
      description
      fundraiserId
      goalAmount
      image
      mainContent
      participants
      raisedAmount
      title
      tournamentDetails
      __typename
    }
  }
`;
export const deleteSlumSoccerGallery = /* GraphQL */ `
  mutation DeleteSlumSoccerGallery($input: DeleteSlumSoccerGalleryInput!) {
    deleteSlumSoccerGallery(input: $input) {
      ef1
      galleryId
      imgUrl
      title
      __typename
    }
  }
`;
export const deleteSlumSoccerNews = /* GraphQL */ `
  mutation DeleteSlumSoccerNews($input: DeleteSlumSoccerNewsInput!) {
    deleteSlumSoccerNews(input: $input) {
      description
      ef1
      ef2
      imgUrl
      link
      newsId
      newspaper
      title
      __typename
    }
  }
`;
export const deleteSlumSoccerPartners = /* GraphQL */ `
  mutation DeleteSlumSoccerPartners($input: DeleteSlumSoccerPartnersInput!) {
    deleteSlumSoccerPartners(input: $input) {
      description
      ef1
      imgUrl
      link
      partnerId
      partnershipType
      title
      __typename
    }
  }
`;
export const deleteSlumSoccerProjects = /* GraphQL */ `
  mutation DeleteSlumSoccerProjects($input: DeleteSlumSoccerProjectsInput!) {
    deleteSlumSoccerProjects(input: $input) {
      description
      ef1
      hoverText
      imgUrl
      mainContent
      projectType
      projectid
      title
      __typename
    }
  }
`;
export const deleteSlumSoccerReports = /* GraphQL */ `
  mutation DeleteSlumSoccerReports($input: DeleteSlumSoccerReportsInput!) {
    deleteSlumSoccerReports(input: $input) {
      date
      description
      ef1
      ef2
      imgUrl
      link
      reportId
      title
      __typename
    }
  }
`;
export const updateSlumSoccerAwards = /* GraphQL */ `
  mutation UpdateSlumSoccerAwards($input: UpdateSlumSoccerAwardsInput!) {
    updateSlumSoccerAwards(input: $input) {
      awardId
      description
      ef1
      ef2
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const updateSlumSoccerBlogs = /* GraphQL */ `
  mutation UpdateSlumSoccerBlogs($input: UpdateSlumSoccerBlogsInput!) {
    updateSlumSoccerBlogs(input: $input) {
      blogId
      date
      description
      ef1
      ef2
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const updateSlumSoccerContacts = /* GraphQL */ `
  mutation UpdateSlumSoccerContacts($input: UpdateSlumSoccerContactsInput!) {
    updateSlumSoccerContacts(input: $input) {
      city
      contactId
      contactNumber
      country
      date
      ef1
      email
      enquiry
      name
      __typename
    }
  }
`;
export const updateSlumSoccerEvents = /* GraphQL */ `
  mutation UpdateSlumSoccerEvents($input: UpdateSlumSoccerEventsInput!) {
    updateSlumSoccerEvents(input: $input) {
      date
      description
      ef1
      ef2
      eventId
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const updateSlumSoccerFundraisers = /* GraphQL */ `
  mutation UpdateSlumSoccerFundraisers(
    $input: UpdateSlumSoccerFundraisersInput!
  ) {
    updateSlumSoccerFundraisers(input: $input) {
      description
      fundraiserId
      goalAmount
      image
      mainContent
      participants
      raisedAmount
      title
      tournamentDetails
      __typename
    }
  }
`;
export const updateSlumSoccerGallery = /* GraphQL */ `
  mutation UpdateSlumSoccerGallery($input: UpdateSlumSoccerGalleryInput!) {
    updateSlumSoccerGallery(input: $input) {
      ef1
      galleryId
      imgUrl
      title
      __typename
    }
  }
`;
export const updateSlumSoccerNews = /* GraphQL */ `
  mutation UpdateSlumSoccerNews($input: UpdateSlumSoccerNewsInput!) {
    updateSlumSoccerNews(input: $input) {
      description
      ef1
      ef2
      imgUrl
      link
      newsId
      newspaper
      title
      __typename
    }
  }
`;
export const updateSlumSoccerPartners = /* GraphQL */ `
  mutation UpdateSlumSoccerPartners($input: UpdateSlumSoccerPartnersInput!) {
    updateSlumSoccerPartners(input: $input) {
      description
      ef1
      imgUrl
      link
      partnerId
      partnershipType
      title
      __typename
    }
  }
`;
export const updateSlumSoccerProjects = /* GraphQL */ `
  mutation UpdateSlumSoccerProjects($input: UpdateSlumSoccerProjectsInput!) {
    updateSlumSoccerProjects(input: $input) {
      description
      ef1
      hoverText
      imgUrl
      mainContent
      projectType
      projectid
      title
      __typename
    }
  }
`;
export const updateSlumSoccerReports = /* GraphQL */ `
  mutation UpdateSlumSoccerReports($input: UpdateSlumSoccerReportsInput!) {
    updateSlumSoccerReports(input: $input) {
      date
      description
      ef1
      ef2
      imgUrl
      link
      reportId
      title
      __typename
    }
  }
`;
